import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #14: Mostly-smooth animation up to 4,000 elements with React and canvas",
  "description": "",
  "published": "2016-07-13T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-14-mostly-smooth-animation-up-to-4000-elements-with-react-and-canvas/swizec/6864"],
  "categories": "Front End, konva, react, react+d3js, reactjs, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Shorter than 500 words. With pictures. You can follow my channel `}<a parentName="em" {...{
          "href": "https://livecoding.tv/swizec"
        }}>{`here`}</a>{`. New content almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat. ?`}</em></p>
    <p>{`We did it! A few thousand elements smoothly animated with React and canvas! Hooray! `}{`\\`}{`o/`}</p>
    <p>{`It’s not perfect. We had to throw the baby away with the bath water and drop down a layer below React. The `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/livecoding-13-rendering-react-components-with-canvas/swizec/6784"
      }}><inlineCode parentName="a">{`updateChildren`}</inlineCode>{` issue from last time`}</a>{` proved too hard to solve. Too hard for `}<em parentName="p">{`me`}</em>{` to solve at least.`}</p>
    <p><img parentName="p" {...{
        "src": "/a145da103f20060c0b36a13624b381cf/4OLlufc.gif",
        "alt": null
      }}></img></p>
    <p>{`We moved our particle rendering logic into `}<inlineCode parentName="p">{`componentDidUpdate`}</inlineCode>{` and rolled up our sleeves. Without React’s help, we were forced to manually keep track of new and old particles.`}</p>
    <p>{`The upside is that we can move existing particles instead of re-creating them. This saves cycles. The downside is that we were unable to remove irrelevant particles efficiently, so they pile up in memory.`}</p>
    <p>{`It’s a garbage collection problem in a way. Animation works well the first time you try it. But if you wait for all the particles to vanish and try again, it’s super slow. That’s because it keeps redrawing particles that are no longer there. Oops.`}</p>
    <p>{`The meat of our code looks like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">componentDidUpdate() {
        let layer = this.refs.the_thing,
            particles = this.props.particles,
        for (let i = 0; i < particles.length; i++) {
            let { id, x, y } = particles[i];

            if (this._particles[id]) {
                // move particle
                this._particles[id].position({
                    x: x,
                    y: y
                });
            }else{
                // create new particle
                let c = new Circle({
                    radius: 1.8,
                    x: x,
                    y: y,
                    fill: 'black'
                });
                this._particles[id] = c;
                layer.add(c);
            }
        };

        layer.batchDraw();
`}</code></pre>
    <p>{`Lovely. `}<inlineCode parentName="p">{`new Circle`}</inlineCode>{` creates a particle, `}<inlineCode parentName="p">{`.position`}</inlineCode>{` updates its position. `}<inlineCode parentName="p">{`layer.batchDraw`}</inlineCode>{` does drawing stuff with the `}<a parentName="p" {...{
        "href": "http://konvajs.github.io/"
      }}>{`Konva`}</a>{` library.`}</p>
    <p>{`This is great, but it’s not perfect. When I stress-tested it later, I discovered an issue. At 4,000 particles, the animation becomes sad. At 7,000 particles, it’s disgusting.`}</p>
    <p><img parentName="p" {...{
        "src": "/e5ea1d4d727b756b509818c1e58b6c80/Y6TDJFX.gif",
        "alt": null
      }}></img></p>
    <p>{`So sad.`}</p>
    <p>{`Just for shits and giggles, I checked the original pure SVG implementation from a few weeks ago. To my surprise, `}<em parentName="p">{`it works better`}</em>{`. Better! React renders and updates pure SVG faster than our hard-earned canvas code does.`}</p>
    <p><img parentName="p" {...{
        "src": "/16296676f3e64239382976e1df92b099/JWublnt.gif",
        "alt": null
      }}></img>{` It takes 7,000 elements to bog down the pure SVG implementation.`}</p>
    <p><img parentName="p" {...{
        "src": "/ce09bbc04b2b10c82b4b41e0a6ed39b2/UElqylu.gif",
        "alt": null
      }}></img>{` Ugh. So annoying. Back to the drawing board.`}</p>
    <p>{`There’s a sliver of hope. Take a good look at those gifs.`}</p>
    <p>{`React+SVG works well up to about 3,000 particles, then quickly bogs down, and has a hard time reaching more than 6,500 particles on screen.`}</p>
    <p>{`React+canvas+Konva works a bit worse at 3,000 particles, but looks like it’s slowing down slower. If that makes sense. It’s not much worse at 5,000 particles than at 3,000. React+SVG at 5,000 looks terrible compared to 3,000.`}</p>
    <p>{`This is promising. It implies that canvas can handle it, but we’re doing something stupid. Maybe Konva is slow, or maybe we’re misusing it.`}</p>
    <p>{`We’ll find out this Sunday :)`}</p>
    <p>{`PS: the edited and improved versions of these videos are becoming a video course. Readers of the engineer package of `}<a parentName="p" {...{
        "href": "http://swizec.com/reactd3js/"
      }}>{`React+d3js ES6`}</a>{` get the video course for free when it’s ready.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      